module.exports = __webpack_public_path__ + "static/img/6.40a19043.jpg";